// 任务列表
import DetermineSubject from './sub-task/determine-subject'     // 确定课题

import SubCommon from './sub-task/sub-common'     // 公共路由

import AcountPassword from './sub-task/acount-password'     // 获取账号密码

export default [
  // 主任务列表
  {
    path: '/TaskList/:seasonId',
    name: 'TaskList',
    meta: {
      Allbtn_info: true
    },
    component: () =>
    import(/* webpackChunkName: "TaskList" */ '@/components/task-list')
  },
  // 二级任务列表
  {
    path: '/TaskSublist',
    name: 'TaskSublist',
    component: () =>
    import(/* webpackChunkName: "TaskSublist" */ '@/components/task-list/sub-list.vue'),
    children: [
      ...DetermineSubject,
      ...SubCommon,
      ...AcountPassword
    ]
  },
  // 写作任务
  {
    path: '/WritingTask',
    name: 'WritingTask',
    component: () =>
    import(/* webpackChunkName: "WritingTask" */ '@/components/sub-task/writing/index.vue')
  },
  // 查看写作任务
  {
    path: '/WritingTaskLook',
    name: 'WritingTaskLook',
    component: () =>
    import(/* webpackChunkName: "WritingTask" */ '@/components/sub-task/writing/look.vue')
  },
  // nec确认组别
  {
    path: '/groupChoice',
    name: 'GroupChoice',
    component: () =>
    import(/* webpackChunkName: "AnwersList" */ '@/components/sub-task/common/group-choice')
  },
  // 确认组别
  {
    path: '/group',
    name: 'Group',
    component: () =>
    import(/* webpackChunkName: "AnwersList" */ '@/components/sub-task/common/group')
  },
  // 全部回答列表
  {
    path: '/AnwersList',
    name: 'AnwersList',
    component: () =>
    import(/* webpackChunkName: "AnwersList" */ '@/components/sub-task/anwers-list/anwers-list')
  },
  // 没有权限
  {
    path: '/NoAuthorityPage',
    name: 'NoAuthorityPage',
    component: () =>
    import(/* webpackChunkName: "AnwersList" */ '@/components/task-list/NoAuthorityPage')
  },
  // 前置任务页面
  {
    path: '/Predecessors',
    name: 'Predecessors',
    component: () =>
      import(/* webpackChunkName: "AnwersList" */ '@/components/task-list/predecessors.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/task-list.js